// eslint-disable-next-line import/no-unresolved
import { useAutoAnimate } from '@formkit/auto-animate/react';
import GestionApp from './GestionApp';

export default function Block( {
	maxBonosComercio,
	remainingBonos,
	progresoConvocatoria,
	status,
} ) {
	// Hook de auto-animate.
	const [ animationParent ] = useAutoAnimate();

	return (
		<div className="sci-bcl-comercio-app" ref={ animationParent }>
			<GestionApp
				maxBonosComercio={ maxBonosComercio }
				remainingBonos={ remainingBonos }
				progresoConvocatoria={ progresoConvocatoria }
				status={ status }
			/>
		</div>
	);
}
